import NotifierTippy from "components/HOCS/NotifierTippy";
import React from "react";
import { useSelector } from "react-redux";
import { selectMeFocus, selectSpaceBoxActive } from "slices/spaceMediaSlice";
import DeviceButtons from "./DeviceButtons/DeviceButtons";
import SpaceBoxActiveControls from "./SpaceBoxActiveControls/SpaceBoxActiveControls";

const MyControlBar = () => {
  const spaceBoxActive = useSelector(selectSpaceBoxActive);
  const meFocus = useSelector(selectMeFocus);
  return (
    <NotifierTippy disabled={spaceBoxActive} arrow={false}>
      <div
        className={`my-control-bar ${
          spaceBoxActive ? "space-box-active" : ""
        } ${meFocus ? "focusing" : ""}`}
      >
        {spaceBoxActive ? <SpaceBoxActiveControls /> : null}
        <DeviceButtons />
      </div>
    </NotifierTippy>
  );
};
export default MyControlBar;
